<svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1996_1165)">
<mask id="path-2-inside-1_1996_1165" fill="white">
<rect x="6.5" y="12.001" width="10.15" height="7" rx="1"/>
</mask>
<rect x="6.5" y="12.001" width="10.15" height="7" rx="1" stroke="currentColor" stroke-width="3.4" mask="url(#path-2-inside-1_1996_1165)"/>
<rect x="18.35" y="12.001" width="10.15" height="7" rx="1" fill="currentColor"/>
<path d="M18.35 21.999L27.5 21.999" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_1996_1165">
<rect width="22" height="22" fill="white" transform="translate(6.5 6)"/>
</clipPath>
</defs>
</svg>
